module.exports = __webpack_public_path__ + "img/info-icon-danger.a8ba246.svg";